import { monthNamesList } from '../constants';
import { FieldOption } from '@mri/types';

type Prop = {
  startMonth?: number;
  startYear?: number;

  mouthCount: number;
}

export function getMonthWithYearOptions(prop: Prop): Array<FieldOption>{
  const { startYear, startMonth, mouthCount } = prop;

  let currentYear:number = startYear || new Date().getFullYear();
  let currentMonth = startMonth || new Date().getMonth();

  const list: Array<FieldOption> = [];

  for(let i = 0; i < mouthCount; i ++){
    if(currentMonth === -1) {
      currentYear = currentYear - 1;
      currentMonth = 11;
    }

    const monthName = monthNamesList[currentMonth] || '';
    list.push({ value: `${currentYear}-${`0${currentMonth + 1}`.slice(-2)}`, label: `${monthName} ${currentYear}`})
    currentMonth = currentMonth - 1;
  }

  return list;
}
